import {DirectiveBinding} from "vue";

const onHover = (event: Event) => {
    if (!event.target) return;
    const el = event.target as HTMLElement;
    el.classList.remove('invisible-scroll');
    if (el.dataset.margin === "true") {
        el.classList.add('mr-1');
    }
};

const onBlur = (event: Event) => {
    if (!event.target) return;
    const el = event.target as HTMLElement;
    if (!el.scrollTop) {
        el.classList.add('invisible-scroll');
    }
    if (el.dataset.margin === "true") {
        el.classList.remove('mr-1');
    }
};

const enable = (el: HTMLElement, margin: any) => {
    el.addEventListener("mouseenter", onHover);
    el.addEventListener("mouseleave", onBlur);
    el.classList.add('overflow-y-auto');
    el.classList.add('invisible-scroll');
    if (margin) {
        el.dataset.margin = "true";
    }
    if (margin) {
        el.classList.remove('mr-1');
    }
}

const disable = (el: HTMLElement) => {
    el.removeEventListener("mouseenter", onHover);
    el.removeEventListener("mouseleave", onBlur);
    if (el.dataset.margin === "true") {
        el.classList.remove('mr-1');
    }
}

export const scrollOnHover = {
    mounted(el: HTMLElement, binding: DirectiveBinding) {
        if (binding.value || binding.value === undefined) {
            enable(el, binding.modifiers.margin);
        }
    },
    updated(el: HTMLElement, binding: DirectiveBinding) {
        if (binding.value || binding.value === undefined) {
            enable(el, binding.modifiers.margin);
        } else {
            disable(el);
        }
    },
    unmounted(el: HTMLElement) {
        disable(el);
    }
}